import {useHalState} from '@synako/haligator';
import {Navigable} from '@synako/halitrek';
import {ArticleDesc} from 'api-types/ffconnect-hal';

export function useVignetteArticle(article: Navigable<ArticleDesc>) {
  const medias = article.follow('medias');
  const {loading, data: principale} = useHalState(
    medias.follow('image_principale'),
  );
  return loading ? undefined : principale?.url;
}
